var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7C18 10.3137 15.3137 13 12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7ZM16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z",
    fill: "#80919F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16C3.79086 16 2 17.7909 2 20V23H4V20C4 18.8954 4.89543 18 6 18H18C19.1046 18 20 18.8954 20 20V23H22V20C22 17.7909 20.2091 16 18 16H6Z",
    fill: "#80919F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfil);
export default __webpack_public_path__ + "static/media/user_profil.4a417e1d94ac5c6116163eb4af680fa0.svg";
export { ForwardRef as ReactComponent };